export default __webpack_public_path__ + "assets/uganda-flag.png";